import {ALLOCATION_ACCOUNT_TYPE_TO_DV_MAPPING} from '@/constants/engine';
import {AllocationAccountType} from '@/repositories/beneva-api/endpoints/allocations';

export const mapAllocationTypeToDomainValue = (type?: AllocationAccountType) => {
  return ALLOCATION_ACCOUNT_TYPE_TO_DV_MAPPING[type ?? AllocationAccountType.CI];
};
